import React from "react";
import "./styles/statsHighlight.css";

const StatsHighlight = () => {
	return (
		<div className="stats-highlight">
			<div className="stat-item">
				<span className="stat-value">60+</span>
				<span className="stat-label">Projects</span>
			</div>
			<div className="stat-divider"></div>
			<div className="stat-item">
				<span className="stat-value">97%</span>
				<span className="stat-label">Client Satisfaction</span>
			</div>
			<div className="stat-divider"></div>
			<div className="stat-item">
				<span className="stat-value">35%</span>
				<span className="stat-label">Average Revenue Increase</span>
			</div>
		</div>
	);
};

export default StatsHighlight;
